import { create } from 'zustand';
import api from '@/lib/api';
import type { ApiResponse } from '@/types/auth';

interface AnalyticsStats {
 totalSessions: number;
 totalProfiles: number;
 totalHoursSpent: number;
 avgResponseTime: string;
 completionRate: string;
}

interface AnalyticsState {
 analytics: any[];
 stats: AnalyticsStats | null;
 isLoading: boolean;
 error: string | null;

 fetchAnalytics: () => Promise<void>;
}

export const useAnalyticsStore = create<AnalyticsState>((set) => ({
 analytics: [],
 stats: null,
 isLoading: false,
 error: null,

 fetchAnalytics: async () => {
  set({ isLoading: true, error: null });
  try {
   const response = await api.get<
    ApiResponse<{ analytics: any[]; stats: AnalyticsStats }>
   >('/analytics');
   set({
    analytics: response.data.data.analytics,
    stats: response.data.data.stats || null,
    isLoading: false,
   });
  } catch (error: any) {
   set({
    error: error.response?.data?.error?.message || 'Failed to fetch analytics',
    isLoading: false,
   });
  }
 },
}));
